export default "__VITE_ASSET__TN$RxFIJ__"